var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classes,attrs:{"loading":_vm.loading,"disabled":_vm.loading},nativeOn:{"click":function($event){return _vm.$emit('exportExcel')}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }